import { render, staticRenderFns } from "./contactdocument-audit.vue?vue&type=template&id=0594a725&scoped=true&"
import script from "./contactdocument-audit.vue?vue&type=script&lang=js&"
export * from "./contactdocument-audit.vue?vue&type=script&lang=js&"
import style0 from "./contactdocument-audit.vue?vue&type=style&index=0&id=0594a725&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0594a725",
  null
  
)

export default component.exports